import graphQLAdapter from "@/adapters/graphQL.adapter.js";
import ProductCategory from "@/entities/productCategory.entity.js";

/**
 * Order Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getProductCategories = getProductCategories.bind(this);
  }
  /**
   * Get the list of orders
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of orders
   */
  async list (clientGroupId) {
    // 2023/9/4 得意先ユーザーの実行には得意先IDが必要になった。
    // https://github.com/TheDesignium/nanokos/pull/143
    const res = await this.getProductCategories(clientGroupId);

    return res.data.productCategories.map(el => ProductCategory.fromJson(el));
  }
}

function getProductCategories (clientGroupId) {
  const variables = {
    clientGroupId,
  };
  const query = `
  query productCategories($clientGroupId: ID) {
    productCategories(clientGroupId: $clientGroupId){
      id
      display
      name
      description
      imageUrl
      products {
        id
        display
        number
        name
        imageUrl
        category {
          id
          name
          description
          imageUrl
        }
      }
    }
  }
`;
  return this.adapter.query(query, variables);
}
